module.exports = __webpack_public_path__ + "assets/img/gn1.f8492198.png";